// @ts-check
import calculate from './wage-calc'
import api from './api'

const wages = ($http) => {
  'ngInject'

  const getMinimumWage = (date, numEmployees, city, county, state) => {
    // this is a hack - adding data:'' and query string instead of params
    // because API V2 improperly demands Content-Type: application/json on all requests
    // and AngualarJS strips it if body is not defined
    const esc = encodeURIComponent
    const query = 'date=' + esc(date)
    + '&numEmployees=' + esc(numEmployees)
    + '&city=' + esc(city)
    + '&county=' + esc(county)
    + '&state=' + esc(state)

    return $http({
      method: 'GET',
      url: `${api.getBaseV2()}/minimum_wages?${query}`,
      data: '',
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(response => {
      return response['data']['wage']
    })
  }

  return {
    getMinimumWage,
    calculate
  }
}

export default wages
